module.exports = "<template>\r\n    <h1><history-back></history-back>Instellingen</h1>\r\n</template>";